import { Map } from "ol"
import { createContext } from "react"

export const OlMapContext = createContext<{ olMap: Map } | null>(null)

